<template>
  <div class="main">
    <report-top> </report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">时间范围</p>
        <start-end ref="startEnd" timeModel="2,3,0"></start-end>
      </div>
      <div class="formTableItem">
        <Button @click="chaxun" size="small" class="chaxun">立即查询</Button>
        <Button @click="openAdd" type="primary" size="small" class="chaxun"
          >下发指令</Button
        >
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(210)"
    >
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <Drawer
      title="下发指令"
      placement="left"
      :closable="true"
      v-model="openForm"
      width="750"
    >
      <Row :gutter="16" style="height: 100%">
        <Col span="8"
          ><locateToolCarPerson
            modal="locate"
            @selectCarList="reCarList"
          ></locateToolCarPerson>
        </Col>
        <Col span="16">
          <Form
            ref="item"
            :model="item"
            :rules="ruleValidate"
            :label-width="80"
          >
            <Row :gutter="16">
              <Col span="24">
                <FormItem label="指令类型" prop="cmdType">
                  <Select v-model="item.cmdType" @on-select="select">
                    <Option
                      v-for="(x, index) in $t('cmdType')"
                      :value="x.name"
                      :tag="x.tab"
                      :key="index"
                      >{{ x.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>

              <template v-if="tag == 1">
                <Col span="24">
                  <FormItem label="指令内容" prop="command">
                    <Input
                      v-model="item.command"
                      :rows="4"
                      type="textarea"
                      placeholder="请输入"
                    ></Input>
                  </FormItem>
                </Col>

                <Col span="24">
                  <FormItem label="类型选项" prop="paramid">
                    <RadioGroup
                      v-model="item.paramid"
                      @on-change="selectParmid"
                    >
                      <Radio
                        v-for="(x, index) in $t('cmdParamid')"
                        :label="index"
                        :key="index"
                        >{{ x }}</Radio
                      >
                    </RadioGroup>
                  </FormItem>
                </Col>
              </template>
              <template v-if="tag == 3">
                <Col span="24">
                  <FormItem label="终端里程" prop="init_mileage">
                    <Input
                      v-model="item.init_mileage"
                      type="number"
                      placeholder="请输入"
                    ></Input>
                  </FormItem>
                </Col>
              </template>
              <template v-if="tag == 4">
                <Col span="24">
                  <FormItem label="终端车牌" prop="vno">
                    <Input v-model="item.vno" placeholder="请输入"></Input>
                  </FormItem>
                </Col>
              </template>
            </Row>
            <Row type="flex" justify="end">
              <Col span="24">
                <div class="btn-wrap">
                  <Button type="primary" @click="addUpdate('item')"
                    >提交表单</Button
                  >
                </div>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Drawer>
  </div>
</template>
<script>
import axios from "axios";
import locateToolCarPerson from "../locate/locateToolCarPerson.vue";
export default {
  components: { locateToolCarPerson },
  data() {
    return {
      openForm: false,
      openDraw: true,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "设备号",
          key: "deviceNo",
        },
        {
          title: "所属单位",
          key: "groupName",
        },
        {
          title: "sim卡号",
          key: "simNo",
        },
        {
          title: "车牌号",
          key: "carNo",
        },
        {
          title: "人员姓名",
          key: "personName",
        },
        {
          title: "指令类型",
          key: "cmdType",
        },
        {
          title: "类型选项",
          key: "cmdDesc",
        },
        {
          title: "指令状态",
          key: "cmdStatus",
          render: (h, data) => {
            return h("div", this.$t("cmdStatus." + data.row.cmdStatus));
          },
        },
        {
          title: "发送内容",
          key: "sendContent",
          tooltip: true,
        },
        {
          title: "发送时间",
          key: "sendTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.sendTime));
          },
        },
        {
          title: "应答内容",
          key: "replyContent",
          tooltip: true,
        },
        {
          title: "应答时间",
          key: "replyTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.replyTime));
          },
        },

        {
          title: "操作人",
          key: "optAccount",
        },
      ],
      tableData: [],
      tag: 1,
      item: {
        cmdType: "TTS文本消息",
        command: "{}",
        deviceIdList: [],
        msgid: "8300",
        cmdDesc: "显示屏显示",
        paramid: "1",
        cmdhead: "",
        init_mileage: 0,
        vno: "",
      },
      ruleValidate: {
        command: { required: true, message: "必填" },
        icon: { required: true, message: "必填" },
      },

      searchItem: {
        deviceIdList: [],
        endTime: 0,
        startTime: 0,
        pageSize: 50,
        pageNumber: 1,
      },
      total: 0,
      deviceIdList: [],
    };
  },
  methods: {
    select(v) {
      this.resetForm();
      var m = v.tag;
      this.tag = m;
      this.item.cmdDesc = "";
      if (m == 1) {
        this.item.cmdDesc = "显示屏显示";
        this.item.command = "";
      } else if (m == 2) {
        this.item.msgid = "8201";
      } else if (m == 3) {
        this.item.msgid = "8103";
        this.item.paramid = "0080";
      } else if (m == 4) {
        this.item.msgid = "8103";
        this.item.paramid = "0083";
      } else if (m == 5) {
        this.item.msgid = "8103";
        this.item.paramid = "0050";
      }
      this.item.cmdType = v.value;
    },
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.cmd + "/record/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.tableData = data;
        console.log(res);
      });
    },
    toJson() {
      var v = this.tag;
      this.item.deviceIdList = this.deviceIdList;

      if (v == 3) {
        var obj = { init_mileage: this.item.init_mileage };
        this.item.command = JSON.stringify(obj);
      } else if (v == 4) {
        var obj = { vno: this.item.vno };
        this.item.command = JSON.stringify(obj);
      }
    },
    addUpdate(name) {
      this.toJson();

      if (this.item.deviceIdList.length == 0) {
        this.$Message.error("请选择车辆");
        return;
      }
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            console.log(this.item);
            axios({
              method: "post",
              url: axios.cmd + "/record/send",
              data: this.item,
            }).then((res) => {
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          } else {
            axios({
              method: "post",
              url: axios.dm + "/carType/update",
              data: this.item,
            }).then((res) => {
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          }
        }
      });
    },
    selectParmid(v) {
      this.item.cmdDesc = this.$t("cmdParamid." + v);
    },
    openAdd() {
      this.openForm = true;
      this.isAdd = true;
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    cliclCancelBtn() {
      this.openForm = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.searchItem.startTime = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endTime = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    reCarList(v) {
      var aaa = [];
      for (let i = 0; i < v.length; i++) {
        aaa.push(v[i].deviceId);
      }
      this.deviceIdList = aaa;
    },
  },
  mounted() {
    this.chaxun();
    this.item.command = "";
    //this.select({ tag: 1 });
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/cmd/index.vue